import * as React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { AnimatedSwitch } from 'react-router-transition';
import { HeaderWithRouter } from './Header';
import { DebateNoteEditForm } from './components/forms/debate-note-form';
import { FaqEditPage } from './components/forms/faq';
import { IssueBriefEditPage } from './components/forms/issue-brief';
import { MediaLinesEditPage } from './components/forms/media-lines-form';
import { MPProfileEditPage } from './components/forms/mp-profile';
import { PersonEditPage } from './components/forms/person';
import { UserCreatePage, UserEditPage } from './components/forms/user-form';
import { ErrorPage } from './pages/Error';
import { Home } from './pages/Home';
import { AdvancedSearch } from './pages/advanced-search';
import { ArchivedContentPage } from './pages/archived-content-page';
import { BriefItemPage } from './pages/brief-item-page';
import { DebateNoteItemPage } from './pages/debate-note-item-page';
import { FaqItemPage } from './pages/faq-item-page';
import { MediaLinesItemPage } from './pages/media-lines-item-page';
import { MPProfileItemPage } from './pages/mp-profile-item-page';
import { NewContentPage } from './pages/new-content';
import { NotFoundPage } from './pages/not-found-page';
import { PersonItemPage } from './pages/person-item-page';
// import { TweetItemPage } from './pages/tweet-item-page';
import { RecentBriefsPage, RecentDebatesPage, RecentFAQPage, RecentPeoplePage, RecentProfilesPage, RecentOpinionEditorialsPage, RecentQuotesPage, RecentAchievementsPage } from './pages/recent-content-page';
import { SignIn } from './pages/sign-in-page';
import { ResourceOnlyTagManagementPage, TagManagementPage } from './pages/tag-management-page';
import PageTitles from "./pages/titles";
import { TodaysLinesPage } from './pages/today-lines-page';
import { UnPublishedDraftsPage } from './pages/unpublished-drafts';
import { UserSearchPage } from './pages/user-search';
import { RoutePaths } from "./route-paths";
import AuthService from './store/auth';
import { ExternalSignIn } from './pages/external-sign-in-page';
import { ResetPasswordPage } from './pages/reset-password-page';
import { ResetTokenPage } from './pages/reset-token-page';
import { OpinionEditorialItemPage } from './pages/opinion-editorial-item-page';
import { OpinionEditorialEditPage } from './components/forms/opinion-editorial-form';
import { Exception } from './components/utility-components';
import { QuoteItemPage } from './pages/quote-item-page';
import { SpeakingListPage } from './pages/speaking-list-page';
import { QuoteEditPage } from './components/forms/new-quote-form';
// import { RecentTweetPage } from 'components/tweetsard/tweetsard-list';
import { AchievementItemPage } from 'pages/achievement-item-page';
import { AchievementEditPage } from 'components/forms/achievement-form';
import { ResourceItemPage } from 'pages/resource-item-page';
import { ResourceEditPage } from 'components/forms/resource-form';
import { ResourcesLandingPage } from 'pages/resources-landing-page';
import { BUILD_ID } from './build-id';

export interface IErrorBoundaryState {
    hasError: boolean;
    error?: any;
    info?: any;
}
export class ErrorBoundary extends React.Component<{}, IErrorBoundaryState> {
    constructor(props: {}) {
        super(props);
        this.state = { 
            hasError: false 
        };
    }
 
    componentDidCatch(error: any, info: any) {
        // Display fallback UI
        this.setState({ hasError: true, error: error, info: info });
        // You can also log the error to an error reporting service
        //logErrorToMyService(error, info);
    }
 
    render() {
        const { hasError, error, info } = this.state;
        if (hasError) {
            // You can render any custom fallback UI
            //return <h1>Something went wrong.</h1>;
            return <Exception type="JsError" stack={error.stack} componentStack={info.componentStack} />;
        }
        return this.props.children;
    }
}


export class Routes extends React.Component<any, any> {
    public render() {
        return <AnimatedSwitch
            atEnter={{ opacity: 0 }}
            atLeave={{ opacity: 0 }}
            atActive={{ opacity: 1 }}
            className="switch-wrapper">
            <Route exact={true} path={RoutePaths.SignIn} component={SignIn} />
            <Route exact={true} path={RoutePaths.External} component={ExternalSignIn} />
            <Route exact={true} path={RoutePaths.ResetPassword} component={ResetPasswordPage} />
            <Route exact={true} path={RoutePaths.ResetPasswordConfirm} component={ResetTokenPage} />
            <DefaultLayout exact={true} path={RoutePaths.Home} component={Home} />

            <DefaultLayout title={PageTitles.LINES} path={RoutePaths.Lines} component={TodaysLinesPage} />

            <DefaultLayout exact={true} title={PageTitles.LINES} path={RoutePaths.MediaLinesItem} component={MediaLinesItemPage} />
            <DefaultLayout exact={true} title={PageTitles.LINES_EDIT} path={RoutePaths.MediaLinesEdit} component={MediaLinesEditPage} />

            <DefaultLayout title={PageTitles.DEBATE_NOTES} path={RoutePaths.Notes} component={RecentDebatesPage/*DebateNotesPage*/} />
            <DefaultLayout exact={true} title={PageTitles.DEBATE_NOTES} path={RoutePaths.NoteItem} component={DebateNoteItemPage} />
            <DefaultLayout exact={true} title={PageTitles.DEBATE_NOTES_EDIT} path={RoutePaths.NoteEditItem} component={DebateNoteEditForm} />

            <DefaultLayout title={PageTitles.MP_PROFILES} path={RoutePaths.MPs} component={RecentProfilesPage/*MPProfileSearch*/} />
            <DefaultLayout exact={true} title={PageTitles.MP_PROFILES} path={RoutePaths.MPItem} component={MPProfileItemPage} />
            <DefaultLayout exact={true} title={PageTitles.MP_PROFILES_EDIT} path={RoutePaths.MPEdit} component={MPProfileEditPage} />

            <DefaultLayout title={PageTitles.PEOPLE} path={RoutePaths.People} component={RecentPeoplePage} />
            <DefaultLayout exact={true} title={PageTitles.PEOPLE} path={RoutePaths.PersonItem} component={PersonItemPage} />
            <DefaultLayout exact={true} title={PageTitles.PEOPLE} path={RoutePaths.PersonItemEdit} component={PersonEditPage} />

            <DefaultLayout title={PageTitles.BRIEFS} path={RoutePaths.IssueBriefs} component={RecentBriefsPage/*BriefsSearch*/} />
            <DefaultLayout exact={true} title={PageTitles.BRIEFS} path={RoutePaths.IssueBriefItem} component={BriefItemPage} />
            <DefaultLayout exact={true} title={PageTitles.BRIEFS_EDIT} path={RoutePaths.IssueBriefEdit} component={IssueBriefEditPage} />

            <DefaultLayout title={PageTitles.ACHIEVEMENTS} path={RoutePaths.Achievements} component={RecentAchievementsPage} />
            <DefaultLayout exact={true} title={PageTitles.ACHIEVEMENTS} path={RoutePaths.AchievementItem} component={AchievementItemPage} />
            <DefaultLayout exact={true} title={PageTitles.ACHIEVEMENTS_EDIT} path={RoutePaths.AchievementEdit} component={AchievementEditPage} />

            <DefaultLayout title={PageTitles.RESOURCES} path={RoutePaths.Resources} component={ResourcesLandingPage} />
            <DefaultLayout exact={true} title={PageTitles.RESOURCES} path={RoutePaths.ResourceItem} component={ResourceItemPage} />
            <DefaultLayout exact={true} title={PageTitles.RESOURCES_EDIT} path={RoutePaths.ResourceEdit} component={ResourceEditPage} />

            <DefaultLayout title={PageTitles.FAQS} path={RoutePaths.FAQ} component={RecentFAQPage/*FAQSearch*/} />
            <DefaultLayout exact={true} title={PageTitles.FAQS} path={RoutePaths.FAQItem} component={FaqItemPage} />
            <DefaultLayout exact={true} title={PageTitles.FAQS_EDIT} path={RoutePaths.FAQEdit} component={FaqEditPage} />

            <DefaultLayout title={PageTitles.OPINION_EDITORIALS} path={RoutePaths.OpinionEditorials} component={RecentOpinionEditorialsPage} />
            <DefaultLayout exact={true} title={PageTitles.OPINION_EDITORIALS} path={RoutePaths.OpinionEditorialItem} component={OpinionEditorialItemPage} />
            <DefaultLayout exact={true} title={PageTitles.OPINION_EDITORIALS} path={RoutePaths.OpinionEditorialEdit} component={OpinionEditorialEditPage} />

            <DefaultLayout title={PageTitles.QUOTES} path={RoutePaths.Quotes} component={RecentQuotesPage} />
            <DefaultLayout exact={true} title={PageTitles.QUOTES} path={RoutePaths.QuoteItem} component={QuoteItemPage} />
            <DefaultLayout exact={true} title={PageTitles.QUOTES} path={RoutePaths.QuoteEdit} component={QuoteEditPage} />
            {/*<DefaultLayout exact={true} title={PageTitles.TWEETS} path={RoutePaths.TweetItem} component={TweetItemPage} />*/}
            <DefaultLayout exact={true} title={PageTitles.SPEAKING_LIST} path={RoutePaths.SpeakingList} component={SpeakingListPage} />


            <DefaultLayout title={PageTitles.USERS_SEARCH} path={RoutePaths.UserSearch} component={UserSearchPage} />
            <DefaultLayout exact={true} title={PageTitles.USERS_CREATE} path={RoutePaths.UserCreate} component={UserCreatePage} />
            <DefaultLayout exact={true} title={PageTitles.USERS_EDIT} path={RoutePaths.UserEdit} component={UserEditPage} />
            
            <DefaultLayout title={PageTitles.ADVANCED_SEARCH} path={RoutePaths.AdvancedSearch} component={AdvancedSearch} />
            <DefaultLayout title={PageTitles.DATA_ENTRY} path={RoutePaths.DataEntry} component={NewContentPage} exact={true} />
            <DefaultLayout title={PageTitles.TAGS} path={RoutePaths.Tags} component={TagManagementPage} exact={true} />
            <DefaultLayout title={PageTitles.RESOURCE_ONLY_TAGS} path={RoutePaths.ResourceOnlyTags} component={ResourceOnlyTagManagementPage} exact={true} />

            <DefaultLayout title={PageTitles.UNPUBLISHED_CONTENT} path={RoutePaths.UnPublishedDrafts} component={UnPublishedDraftsPage} />
            <DefaultLayout exact={true} title={PageTitles.ARCHIVED_CONTENT} path={RoutePaths.ArchivedContent} component={ArchivedContentPage} />

            <Route path='/error/:code?' component={ErrorPage} />
            <Route path='/page-not-found' component={NotFoundPageWithHeader} />
        </AnimatedSwitch>
    }
}

const renderHeader = (title?: string) => <HeaderWithRouter title={title} />;

const NotFoundPageWithHeader = (props: any) => {
    return <>
        {renderHeader(PageTitles.NOT_FOUND)}
        <NotFoundPage {...props} />
    </>;
}

interface IDefaultLayoutProps {
    component: any;
    path: string;
    title?: string;
    exact?: boolean;
}

const DefaultLayout = ({ component: Component, title, ...rest }: IDefaultLayoutProps) => (
    // tslint:disable-next-line:jsx-no-lambda
    <Route {...rest} render={props => (
        AuthService.isLoggedOn() ? (
            <>
                {renderHeader(title)}
                <ErrorBoundary>
                    <Component {...props} />
                    <div style={{ float: 'right', margin: '30px' }}>Build ID: <strong>{BUILD_ID}</strong>. Need help? <a href={`mailto:researchhub@labour.org.nz`}>researchhub@labour.org.nz</a></div>
                </ErrorBoundary>
            </>)
            : <Redirect to={{ pathname: RoutePaths.SignIn }} />
    )} />
);



// WEBPACK FOOTER //
// ./src/Routes.tsx